import { render, staticRenderFns } from "./NhsafeOrganizationChart.vue?vue&type=template&id=463a5b15&scoped=true&"
import script from "./NhsafeOrganizationChart.vue?vue&type=script&lang=js&"
export * from "./NhsafeOrganizationChart.vue?vue&type=script&lang=js&"
import style0 from "./NhsafeOrganizationChart.vue?vue&type=style&index=0&id=463a5b15&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463a5b15",
  null
  
)

export default component.exports